export const subNavBarFPTIs = {
  subNavBarHome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:sub-navbar',
    comp: 'smarthelpnodeweb',
  },
};

export const newExperienceFPTIs = {
  newHomeExperienceError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:new-exp-error',
    event_name: 'new_experience_failed_to_load',
    e: 'ac',
  },
};

export const alertsFPTIs = {
  alertsHome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:alerts',
    comp: 'smarthelpnodeweb',
  },
  alertsContactUs: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:alerts',
    comp: 'smarthelpnodeweb',
  },
};
